import { render, staticRenderFns } from "./CalculationResults.vue?vue&type=template&id=6ca73223&scoped=true"
import script from "./CalculationResults.vue?vue&type=script&lang=js"
export * from "./CalculationResults.vue?vue&type=script&lang=js"
import style0 from "./CalculationResults.vue?vue&type=style&index=0&id=6ca73223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca73223",
  null
  
)

export default component.exports